import { RangeHorizon, ResampleIntervals } from '@toggle/chart';
import { Entity } from '@toggle/toggle';
import React from 'react';

import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { OverviewEventFeed } from '~/modules/overview-event-feed/OverviewEventFeed';
import { SimpleChart } from '~/modules/simple-chart/SimpleChart';
import { POSTHOG_TRACKING_SOURCES } from '~/services/tracking/posthog/constants';

import styles from './CompanyCatalystFullViewDrawer.module.scss';

export const CompanyCatalystFullViewDrawer = ({
  entity,
}: {
  entity: Entity;
}) => {
  const chartSettings = {
    assets: [
      {
        tag: entity?.tag ?? '',
        snake: entity?.default_snake ?? '',
        paneIndex: 0,
      },
    ],
    resample: ResampleIntervals.OneDay,
    horizon: RangeHorizon.OneMonth,
    domain: null,
    hidden: undefined,
    paneSettings: {},
  };

  return (
    <div className={styles.container}>
      <ErrorBoundaryWrapper>
        <SimpleChart
          entity={entity}
          source={POSTHOG_TRACKING_SOURCES.CATALYST_INSIGHT_DRAWER}
          initialChartSettings={chartSettings}
          showChartTypeSelector={false}
          eventsConfig={{ TMI: true }}
        />
        <OverviewEventFeed
          entityTag={entity.tag}
          period="1M"
          showViewAllButton
          source={POSTHOG_TRACKING_SOURCES.CATALYST_INSIGHT_DRAWER}
        />
      </ErrorBoundaryWrapper>
    </div>
  );
};
